import React, { useEffect, useRef } from 'react';
// import Papa from "papaparse";

const RouteChart = () => {
    // const [chartData, setChartData] = useState("");
    let file = useRef("");

    const load = function(){
        const reader = new FileReader();
        reader.onload = async ({target}) =>{
            // const csv = Papa.parse(target.result, {
            //     header: true,
            // });
            // const parsedData = csv?.data;
            // const headers = Object.keys(parsedData[0]);
            // const columns = Object.values(parsedData);
            // console.log(headers, columns);
            // setChartData(columns);
        };
        reader.readAsText(file.current);
    };
    const handleFileChange = (e) => {
 
        // Check if user has entered the file
        if (e.target.files.length) {
            const inputFile = e.target.files[0];
            // Check the file extensions, if it not
            // included in the allowed extensions
            // we show the error
            const fileExtension = inputFile?.type.split("/")[1];
            if (!["csv"].includes(fileExtension)) 
            {
                return;
            }
 
            // If input type is correct set the state
            file = inputFile;
            load();
            
        }
    };
    useEffect(() => {
        
        return () => {
            
        };
    }, []);


    return (
        <div className='row w-100 m-auto'>
            <div className='col my-2 px-2'>
                <b className='text-center d-block'>Route Data Chart</b>
                <input type='File' name='File' onChange={handleFileChange}/>
                <div id='routeChartBlock' className='w-100' style={{height:"400px", background:"lightblue"}}>

                </div>
            </div>
        </div>
    );
}

export default RouteChart;